import { useDebugValue, useContext } from "react";
import { SystemContext } from "./auth-service-tools658.js";

function useToken(token, defaultValue) {
  useDebugValue(token);
  var context = useContext(SystemContext);
  return context[token] != null ? context[token] : defaultValue;
}

export { useToken };